// extracted by mini-css-extract-plugin
module.exports = {"wrap":"HomeView_wrap__DlTrZ","name":"HomeView_name__3D4vP","wrapMast":"HomeView_wrapMast__KJKQf","toTopBtn":"HomeView_toTopBtn__24PRY"};